import { createApp } from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import apolloProvider from '@/apollo'
import { createPinia } from 'pinia'
import safeHTMLPlugin from '@/design/plugins/safe-HTML'
import snackbarPlugin from '@/plugins/snackbar'
import confirmPlugin from '@/plugins/confirm/confirm'
import microservicesPlugin from '@/plugins/microservices/microservices'
import legacyHostGlobalsPlugin from '@/plugins/legacyHostGlobals'
import vuelidatePlugin from '@/plugins/vuelidate'
import { useUserStore } from '@/store/userStore'

const pinia = createPinia()

const app = createApp(App)
app
  .use(vuetify)
  .use(router)
  .use(apolloProvider)
  .use(pinia)
  .use(safeHTMLPlugin)
  .use(snackbarPlugin)
  .use(confirmPlugin, {
    vuetify,
    router,
    pinia,
    safeHTMLPlugin,
  })
  .use(microservicesPlugin, {
    env: process.env,
  })
  .use(legacyHostGlobalsPlugin)
  .use(vuelidatePlugin)
;(async () => {
  try {
    const userStore = useUserStore()
    await userStore.getDataFromLocalStorage()
  } finally {
    app.mount('#app')
  }
})()
